
import React, { Component } from "react";
import { Link } from "react-router-dom";
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
  Table,
  Spinner,
  FormGroup, Label, Modal, ModalHeader, ModalBody, Collapse, CardHeader
} from "reactstrap";
import { AvForm, AvField } from "availity-reactstrap-validation";
import { validateToken, has_Permission } from '../../helpers/jwt-token-access/accessToken'
import classnames from "classnames";
import Select from "react-select";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { BaseUrl } from "../../helpers/Baseurl";
import SweetAlert from "react-bootstrap-sweetalert";
import toastr from 'toastr'
import 'toastr/build/toastr.min.css'
//Import Star Ratings
import StarRatings from "react-star-ratings";
import { isEmpty } from "lodash";

import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";
import default_img from '../../assets/images/noimg.jpeg'

import { Dates, Months,months_name } from '../../helpers/methods'

const customStyles = {
    overlay: {
        marginTop: '70px'
    }
}

class HotelDetailPage extends Component {
  constructor(props) {
    super(props);
    this.obj = this.props.obj
    if (this.props.obj){
        if (!validateToken(this.props.obj.access)){
          this.props.history.push('/logout')
        }  
      }
    this.state = {
      isFits:false,
      images : [],
      images_name :[],
      photoIndex:0,
      selected_pricing: false,
      model_EditPricing:false,
      model_facility:false,
      alert_confirm : false,
      success_confirm : false,
      facilityloading:false,
      editpriceloading:false,
      selectedStartMonth: { label: "Jan", value: 1 },
      selectedEndMonth: { label: "Jan", value: 1 },
      selectedStartDate: { label: "1", value: '1' },
      selectedEndDate: { label: "1", value: '1' },
      selectedRoom: { label: "Select Room", value: null },
      dynamic_title: "",
      dynamic_description: "",
      pricing_id:"",
      activeTab: 1,
      activepricingTab: "hotel_detail",
      hotel: {},
      terms:[],
      guidelines:[],
      menue:[],
      pricing:[],
      selectedFacilities:[], 
      FacilityGroup:[],
      DestinationDistances:[],
      bank_detail:[],
      room_facilities:[],
      RoomGroup:[],
      
      
    };
    toastr.options = {
      positionClass: "toast-top-right",
      closeButton: "true",
      progressBar: "true",
      showEasing: "swing",
      hideEasing: "linear",
      showMethod: "fadeIn",
      hideMethod: "fadeOut",
      showDuration: 300,
      hideDuration: 1000,
      timeOut: 5000,
      extendedTimeOut: 1000
    }

    this.toggleTab = this.toggleTab.bind(this);
    this.togglepricing = this.togglepricing.bind(this);
    this.handlePricingDelete = this.handlePricingDelete.bind(this)
    this.handleFacilitySubmit = this.handleFacilitySubmit.bind(this)
    this.handlePricingSubmit = this.handlePricingSubmit.bind(this)
    this.handleselectedFacilityGroup = this.handleselectedFacilityGroup.bind(this);
    this.HandleEditPricing = this.HandleEditPricing.bind(this);
    this.imageShow = this.imageShow.bind(this);
    this.tog_facility = this.tog_facility.bind(this);
    this.tog_EditPricing = this.tog_EditPricing.bind(this);
    this.tog_AddSeason = this.tog_AddSeason.bind(this);
    this.tog_EditSeason = this.tog_EditSeason.bind(this);
    this.tog_room_facility = this.tog_room_facility.bind(this);
    this.tog_edit_bank_detail = this.tog_edit_bank_detail.bind(this);
    this.handleSeasonSubmit = this.handleSeasonSubmit.bind(this);
    this.handleEditSeasonSubmit = this.handleEditSeasonSubmit.bind(this);
    this.handleBankDetailSubmit = this.handleBankDetailSubmit.bind(this);
    this.t_col1 = this.t_col1.bind(this);
		this.t_col2 = this.t_col2.bind(this);
		this.t_col3 = this.t_col3.bind(this);
  }

  componentDidMount() {
    this.loadData()
    this.loadFacilitiesData()
    this.loadRoomsData()
    if(this.obj){
        this.loadPaymentDetail()
    }
    
  }

  loadData(){
    const id =this.props.id
    const requestOptions = {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    };
    fetch(`${BaseUrl}/api/hotels/hotels/${id}/`,requestOptions)
        .then(res => res.json())
        .then(
            (data) => { 
              document.title = data.hotel.name+" | Planmans";
              this.loadDestinationDistances(data.hotel.destination.id)
              this.setState({ hotel:data.hotel, pricing:data.pricing, pricing_id:"", seasons:data.seasons, 
                              terms:data.terms, guidelines: data.guidelines, menue:data.menue })    
               
            },
            (error) => {
                console.log(error, 'error--------------') 
            }
        ) 
  }

  async loadRoomsData(){

    const requestOptions = {
      method: 'GET',
      headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.obj.access}` },
    };
    await fetch(`${BaseUrl}/api/hotels/rooms_types/`,requestOptions)
        .then(res => {
          if (res.status >= 400){
            res.json()
            .then((data) =>{
              console.log( data,'error--------------')
            })
             
          }else{
            res.json()
            .then(
              (data) => {
                  let options = []
                  data.map(room => {
                    options.push({ label: room.name, value: room.id })
                  })
                  let selectedRoom= ""
                  if (options.length >0){
                    selectedRoom = options[0]
                  }
                  let RoomGroup = [
                    { 
                      label: "Rooms",
                      options: options
                    }
                  ];
                  this.setState({ RoomGroup: RoomGroup,
                    selectedRoom: selectedRoom,
                  
                  })           
                 
              },
              (error) => {
                  console.log(error, 'error--------------') 
              }
          )  
          }
          
        })
        
   }

  async loadPaymentDetail(){
    const id =this.props.id
    const requestOptions = {
      method: 'GET',
      headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.obj.access}`},
    };
    fetch(`${BaseUrl}/api/hotels/hotel-bank-detail/?hotel__id=${id}`,requestOptions)
        .then(res => res.json())
        .then(
            (data) => {
              this.setState({ bank_detail:data.results[0],  loading_bank_detail: false, model_edit_bank_detail:false })    
               
            },
            (error) => {
                console.log(error, 'error--------------') 
            }
        ) 
  }

  async loadDestinationDistances(id){
    
    const requestOptions = {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    };
    await fetch(`${BaseUrl}/api/locations/location/destination_distance/?from_destination__id=${id}`,requestOptions)
        .then(res => res.json())
        .then(
            (data) => {
                this.setState({ DestinationDistances: data })           
            },
            (error) => {
                console.log(error, 'error--------------') 
            }
        )  
  }

  async loadFacilitiesData() {
    const requestOptions = {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    };
  
    await fetch(`${BaseUrl}/api/hotels/rooms_facilities/`, requestOptions)
      .then(res => res.json())
      .then(
        (data) => {
          let options = data.map(facility => ({
            label: facility.name, value: facility.id
          }));
  
          // Add "Select All" option
          options.unshift({ label: "Select All", value: "all" });
  
          let FacilityGroup = [
            {
              label: "Facilities",
              options: options
            }
          ];
  
          this.setState({ FacilityGroup });
        },
        (error) => {
          console.log(error, 'error--------------');
        }
      );
  }
  
   
  tog_EditPricing() {
    this.setState(prevState => ({
      model_EditPricing: !prevState.model_EditPricing
    }));
    this.removeBodyCss();
  }
  

  tog_facility() {
    this.setState(prevState => ({
      model_facility: !prevState.model_facility
    }));
    this.removeBodyCss();
  }

  tog_room_facility() {
    this.setState(prevState => ({
      model_room_facility: !prevState.model_room_facility
    }));
    this.removeBodyCss();
  }

  tog_AddSeason() {
    this.setState(prevState => ({
      model_AddSeason: !prevState.model_AddSeason
    }));
    this.removeBodyCss();
  }

  tog_EditSeason() {
    this.setState(prevState => ({
      model_EditSeason: !prevState.model_EditSeason
    }));
    this.removeBodyCss();
  }

  tog_edit_bank_detail() {
    this.setState(prevState => ({
        model_edit_bank_detail: !prevState.model_edit_bank_detail
    }));
    this.removeBodyCss();
  }

  removeBodyCss() {
    document.body.classList.add("no_padding");
  }

  toggleTab(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab,
      });
    }
  }

  togglepricing(tab) {
    if (this.state.activepricingTab !== tab) {
      this.setState({
        activepricingTab: tab,
      });
    }
  }

  t_col1() {
		this.setState({ col1: !this.state.col1, col2: false, col3: false });
	}
	t_col2() {
		this.setState({ col2: !this.state.col2, col1: false, col3: false });
	}
	t_col3() {
		this.setState({ col3: !this.state.col3, col1: false, col2: false });
	}

  imageShow(img, id) {
    const expandImg = document.getElementById("expandedImg" + id);
    expandImg.src = img;
  }

  // Load Create Hotels images list for Lightbox Gallery
  onImageClick(images){
    let image = []
    let images_name= []
    for (let i=0; i<images.length; i++){
        image.push(BaseUrl+images[i].image)
        images_name.push(images[i].name)
    }
    this.setState({ isFits: true, photoIndex: 0, images:image, images_name})
  }

  HandleEditPricing(item){
    let selectedRoom= { label: item.room_type.name, value: item.room_type.id }
    let facilities = item.facilities
    let selectedFacilities = []
    for(let i=0; i<facilities.length; i++){
      selectedFacilities.push({label: facilities[i].name, value: facilities[i].id})
    }
    this.setState({ model_EditPricing:true, selected_pricing:item, selectedFacilities:selectedFacilities, selectedRoom })
  }

  handleselectedFacilityGroup = selectedFacilities => {
    // Check if "Select All" is selected
    if (selectedFacilities.some(facility => facility.value === "all")) {
      // If "Select All" is selected, select all options except "Select All"
      this.setState({
        selectedFacilities: this.state.FacilityGroup[0].options.filter(f => f.value !== "all")
      });
    } else {
      // If "Select All" is deselected, update normally
      this.setState({ selectedFacilities });
    }
  };
  

  handleSelectedStartMonth = selectedStartMonth => {
    this.setState({ selectedStartMonth });
  }

  handleSelectedEndMonth = selectedEndMonth => {
    this.setState({ selectedEndMonth });
  }

  handleSelectedStartDate = selectedStartDate => {
    this.setState({ selectedStartDate });
  }

  handleSelectedEndDate = selectedEndDate => {
    this.setState({ selectedEndDate });
  }

  // Deleted Hotel Selected Price 
  handlePricingDelete = id => { 
    const requestOptions = {
        method: 'DELETE',
        headers: { 'Authorization': `Bearer ${this.obj.access}` },
    
        };
          fetch(`${BaseUrl}/api/hotels/room_pricing/${id}/`,requestOptions)
                .then(res => 
                    {if(res.status >= 400){
                      console.log("error")
                    }
                    else{
                      this.loadData();
                      this.setState({
                        pricing_id:"",
                        success_confirm: true,
                        alert_confirm : false,
                        dynamic_title: "Deleted!",
                        dynamic_description: "Price has been deleted."
                        })
                    }
                }
            )
  }

  // Create New Facility   
  handleFacilitySubmit(e) {
    e.preventDefault(); // Prevent default form submission behavior
  
    this.setState({ facilityloading: true });
  
    // Extract only facility IDs and remove "Select All"
    const facilityIds = this.state.selectedFacilities
      .filter(facility => facility.value !== "all") // Exclude "Select All"
      .map(facility => facility.value); // Extract only IDs
  
    if (facilityIds.length === 0) {
      toastr.error("Please select at least one facility.");
      this.setState({ facilityloading: false });
      return;
    }
  
    const requestOptions = {
      method: "POST",
      headers: { 
        "Content-Type": "application/json", 
        "Authorization": `Bearer ${this.obj.access}` 
      },
      body: JSON.stringify({ facilities: facilityIds }) // Send only the facility IDs
    };
  
    fetch(`${BaseUrl}/api/hotels/rooms_facilities/`, requestOptions)
      .then(res => {
        if (res.status >= 400) {
          return res.json().then(() => {
            toastr.error("Something Went Wrong", "");
            this.setState({ facilityloading: false });
          });
        } else {
          return res.json().then(() => {
            this.loadFacilitiesData();
            this.setState({ facilityloading: false, model_facility: false });
            toastr.success("Facilities updated successfully!");
          });
        }
      })
      .catch(error => {
        console.error("Submission error:", error);
        toastr.error("Failed to submit facilities.");
        this.setState({ facilityloading: false });
      });
  }
  

  // Save Updated Selected Hotel Price Data 
  handlePricingSubmit(e, values){
    this.setState({ editpriceloading: true })
    const { selectedFacilities, selected_pricing, hotel, selectedRoom } = this.state
      let facilities = []
      for(let i=0 ; i<selectedFacilities.length; i++){
          facilities.push(selectedFacilities[i].value)
      }   
      let data = {}
      data["hotel"]= hotel.id
      data["room_type"]= selectedRoom.value
      data["extra_bed_price"]= 0
      data["ep_price"]= values.ep_price
      data["cp_price"]= values.cp_price
      data["map_price"]= values.map_price
      data["on_season_ep_price"]= values.on_season_ep_price
      data["on_season_cp_price"]= values.on_season_cp_price
      data["on_season_map_price"]= values.on_season_map_price
      if(facilities.length !== 0){
        data["facilities"]= facilities
      }

    const requestOptions = {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.obj.access}` },
      body: JSON.stringify(data)
      };
      fetch(`${BaseUrl}/api/hotels/room_pricing/${selected_pricing.id}/`,requestOptions)
            .then(res => 
                {if(res.status >= 400){
                    res.json()
                    .then(
                        (data) =>{ 
                          console.log( data, "----error") 
                          toastr.error("Something Went Wrong", "") 
                          this.setState({ facilityloading: false })
                        }     
                    )
                }
                else{
                  this.loadData()
                  this.setState({editpriceloading: false, model_EditPricing: false, selected_pricing:false })
                }    
            }
        )

  }
  // Create New Hotel Season 
  handleSeasonSubmit(){
    const {hotel, selectedEndDate, selectedEndMonth, selectedStartDate, selectedStartMonth} = this.state
    this.setState({addSeasonloading:true})
    let data = {
      "start_date": selectedStartDate.value,
      "start_month": selectedStartMonth.value,
      "end_date": selectedEndDate.value,
      "end_month": selectedEndMonth.value,
      "hotel": hotel.id
    }
    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.obj.access}` },
      body: JSON.stringify(data)
      };
      fetch(`${BaseUrl}/api/hotels/hotel_seasons/`,requestOptions)
            .then(res => 
                {if(res.status >= 400){
                  toastr.error("Something Went Wrong", "") 
                  this.setState({ addSeasonloading: false })
                }
                else{
                    this.loadData()
                    this.setState({addSeasonloading: false, model_AddSeason:false })
                }    
            }
        )
  }
  // Delete Selected Hotel Season 
  handleSeasonDelete = id => {
    const requestOptions = {
      method: 'DELETE',
      headers: { 'Authorization': `Bearer ${this.obj.access}` },
  
      };
        fetch(`${BaseUrl}/api/hotels/hotel_seasons/${id}/`,requestOptions)
              .then(res => 
                  {if(res.status >= 400){
                    console.log("error")
                    toastr.error("Something Went Wrong", "") 
                    this.setState({
                      pricing_id:"",
                      season_success_confirm: false,
                      season_alert_confirm : false,
                      })
                  }
                  else{
                    this.loadData();
                    this.setState({
                      pricing_id:"",
                      season_success_confirm: true,
                      season_alert_confirm : false,
                      dynamic_title: "Deleted!",
                      dynamic_description: "Season has been deleted."
                      })
                  }
              }
          )

  }
  //  Load selected Season Data to state for display in Model 
  handleSeasonEdit = row => {
    let selectedEndDate = { label: row.end_date, value: row.end_date }
    let selectedEndMonth = { label: months_name[row.end_month-1], value: row.end_month }
    let selectedStartDate = { label: row.start_date, value: row.start_date }
    let selectedStartMonth = { label: months_name[row.start_month-1], value: row.start_month }
    this.setState({selectedEndDate, selectedEndMonth, selectedStartDate, selectedStartMonth, model_EditSeason:true, pricing_id:row.id  })

  }

  // Save Updated Season Data 
  handleEditSeasonSubmit(){
    const {hotel, selectedEndDate, selectedEndMonth, selectedStartDate, selectedStartMonth, pricing_id} = this.state
    this.setState({editSeasonloading:true})
    let data = {
      "start_date": selectedStartDate.value,
      "start_month": selectedStartMonth.value,
      "end_date": selectedEndDate.value,
      "end_month": selectedEndMonth.value,
      "hotel": hotel.id
    }
    const requestOptions = {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.obj.access}` },
      body: JSON.stringify(data)
      };
      fetch(`${BaseUrl}/api/hotels/hotel_seasons/${pricing_id}/`,requestOptions)
            .then(res => 
                {if(res.status >= 400){
                    res.json()
                    .then(
                        (data) =>{  
                          toastr.error("Something Went Wrong", "") 
                          this.setState({ editSeasonloading: false, pricing_id:"" })
                        }     
                    )
                }
                else{
                  this.loadData()
                  this.setState({editSeasonloading: false, model_EditSeason:false, pricing_id:"" })
                }    
            }
        )
  }
  // Save Bank Details
  handleBankDetailSubmit(e, values){
    const { bank_detail, hotel } = this.state
    this.setState({ loading_bank_detail: true })
    let data = {  'bank_name': values.bank_name,
                  'ifsc':values.ifsc,
                  'account_no':values.account_no,
                  'upi':values.upi,
                  'account_name':values.account_name,
                  'branch_name':values.branch_name,
                  'upi_bank_name':values.upi_bank_name,
                  'upi_user_name':values.upi_user_name,
                  'hotel': hotel.id,
                 }

    if(bank_detail){
      const requestOptions = {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.obj.access}` },
        body: JSON.stringify(data)
      };
      fetch(`${BaseUrl}/api/hotels/hotel-bank-detail/${bank_detail.id}/`,requestOptions)
            .then(res => 
                {if(res.status >= 400){
                    res.json()
                    .then(
                        (data) =>{  
                          console.log(data, "---data")
                          this.setState({ loading_bank_detail: false })
                        }
                          
                    )
                }
                else{
                  this.loadPaymentDetail()
                }    
            }
        )
    }else{
      const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.obj.access}` },
        body: JSON.stringify(data)
      };
      fetch(`${BaseUrl}/api/hotels/hotel-bank-detail/`,requestOptions)
            .then(res => 
                {if(res.status >= 400){
                    res.json()
                    .then(
                        (data) =>{  
                          console.log(data, "---data")
                          this.setState({ loading_bank_detail: false })
                        }
                    )
                }
                else{
                  this.loadPaymentDetail()
                }    
            }
        )
    }
  }

  ShowRoomFacilites(facilities){
    this.setState({room_facilities: facilities})
    this.tog_room_facility()

  }


  render() {
    const { hotel, pricing , selected_pricing, selectedFacilities, FacilityGroup,  images, photoIndex, images_name,
            bank_detail, terms, guidelines, menue} = this.state;
    let breadcrumbItems = [
      { title: "Hotels", link: "/hotels" },
      { title: (hotel.name? hotel.name: "Hotel Detail"), link: "#" },
      ]
    

    const HotelFacility = ({ innerRef, innerProps, isDisabled, children }) =>
    !isDisabled ? (
        <div id="add_state" ref={innerRef} {...innerProps} className="customReactSelectMenu">
            {children}
            <Link to="#" onClick={this.tog_facility}  className="text-warning"><i className="mdi mdi-plus font-size-18"></i></Link>

        </div>
    ) : null;

    return (
      <React.Fragment>
        <div className={this.obj?"page-content":"mt-4"}>
          <Container fluid>
          {this.obj?
            <Breadcrumbs
              title={""}
              breadcrumbItems={breadcrumbItems}
            />:null}

            {/* {!isEmpty(hotel) && ( */}
              <React.Fragment>
                  {!isEmpty(hotel)?
                 
                  <Row>
                    {this.state.isFits ? (
                       <Lightbox
                            
                       reactModalStyle = {this.obj?customStyles:""}
                       mainSrc={images[photoIndex]}
                       nextSrc={images[(photoIndex + 1) % images.length]}
                       prevSrc={
                       images[(photoIndex + images.length - 1) % images.length]
                       }
                       enableZoom={true}
                       onCloseRequest={() => this.setState({ isFits: false })}
                       onMovePrevRequest={() =>
                       this.setState({
                           photoIndex: (photoIndex + images.length - 1) % images.length
                       })
                       }
                       onMoveNextRequest={() =>
                       this.setState({
                           photoIndex: (photoIndex + 1) % images.length
                       })
                       }
                       imageCaption={
                             `Image : ${images_name[photoIndex]}`
                           }
                     />
                    ) : null}
                    <Col lg={12}>
                      <Card>
                        <CardBody>
                          <Row>
                            <Col xl="5">
                              <div className="hotel-detail">
                                <Row>
                                  <Col xs="3" className="scroll-y">
                                    <Nav className="flex-column" pills>
                                    {hotel.images.map(
                                            (item, i) => ( 
                                              
                                      <NavItem>
                                        <NavLink
                                          className={classnames({
                                            active: this.state.activeTab === i+1,
                                          })}
                                          onClick={() => {
                                            this.toggleTab(i+1);
                                          }}
                                        >
                                          <img
                                            src={BaseUrl+item.image}
                                            alt={item.name}
                                            onClick={() => {
                                              this.imageShow(BaseUrl+item.image, i+1);
                                            }}
                                            className="img-fluid mx-auto d-block tab-img rounded"
                                          />
                                        </NavLink>
                                      </NavItem>
                                      ))}
                                    </Nav>
                                  </Col>
                                  <Col xs="9">
                                    <TabContent
                                      activeTab={this.state.activeTab}
                                      className="position-relative"
                                    >
                                      {hotel.images.length >0?
                                      hotel.images.map(
                                            (item, i) => (  
                                      <TabPane tabId={i+1}>
                                        <div className="hotel-img" style={{backgroundColor:"gray", height:"350px"}}>
                                          <img
                                            onClick= {() => this.onImageClick(hotel.images)}
                                            src={BaseUrl+item.image}
                                            alt=""
                                            id={"expandedImg"+(i+1)}
                                            className="img-fluid mx-auto d-block"
                                            style={{ maxHeight:"350px", position: "absolute", top: "50%", left: "50%" ,transform: `translateX(-50%) translateY(-50%)`}}
                                          />
                                        </div>
                                      </TabPane>
                                      )):
                                      <TabPane tabId={1}>
                                        <div className="hotel-img" style={{backgroundColor:"gray", height:"350px"}}>
                                          <img
                                            src={default_img}
                                            alt=""
                                            id={"expandedImg"}
                                            className="img-fluid mx-auto d-block"
                                            style={{ maxHeight:"350px", position: "absolute", top: "50%", left: "50%" ,transform: `translateX(-50%) translateY(-50%)`}}
                                          />
                                        </div>
                                      </TabPane>}
                                    </TabContent>
                                  </Col>
                                </Row>
                              </div>
                            </Col>

                            <Col xl="7">
                              <div className="mt-4 mt-xl-3">
                              
                                <h5 className="mt-1 mb-3">{hotel.name}</h5>

                                <div className="d-inline-flex">
                                  <div className="text-muted me-3">

                                    <StarRatings
                                      rating={hotel.rating}
                                      starRatedColor="#F1B44C"
                                      starEmptyColor="#2D363F"
                                      numberOfStars={5}
                                      name="rating"
                                      starDimension="14px"
                                      starSpacing="3px"
                                    />

                                  </div>
                                </div>

                                <hr className="my-4" />
                                
                                <Row>
                                  
                                  <Col md="12">
                                    <div>
                                        <h5 className="font-size-14">
                                          <i className="mdi mdi-location"></i>{" "}
                                          Description
                                        </h5>
                                        <p className="mt-3">{hotel.description}</p>
                                      </div>
                                  
                                  </Col>
                                  <Col md="12">
                                      <div>
                                        <h5 className="font-size-14">
                                          Facilities :
                                        </h5>
                                        <ul className="list-unstyled hotel-desc-list">
                                          <Row>
                                          
                                          {hotel.facilities.map(
                                              (item, i) => ( 
                                                <Col md="6">
                                                  <li key={i}>
                                                    <i className="mdi mdi-circle-medium me-1 align-middle"></i>{" "}
                                                    {item.name}
                                                  </li>
                                                </Col>
                                              ))
                                          }  
                                          </Row>
                                        
                                        </ul>
                                      </div>
                                  </Col>
                                  <Col md={12}>
                                    <div id="accordion">
                                      <Card className="mb-1 shadow-none">
                                        <Link to="#" onClick={this.t_col1} style={{ cursor: "pointer" }} className="text-dark" >
                                          <CardHeader id="headingOne">
                                            <h6 className="m-0 font-size-14">
                                                Buffet Menu:
                                              <i className={this.state.col1 ? "mdi mdi-minus float-end accor-plus-icon" : "mdi mdi-plus float-end accor-plus-icon"}></i>
                                            </h6>
                                          </CardHeader>
                                        </Link>
                                        <Collapse isOpen={this.state.col1}>
                                          <CardBody>
                                          <p>
                                            {menue.map((menu) => {
                                              return (<><b>{menu.meal}: </b>{menu.items}<br /></>)
                                            })}
                                            </p>
                                          </CardBody>
                                        </Collapse>
                                      </Card>
                                      <Card className="mb-1 shadow-none">
                                        <Link to="#" onClick={this.t_col2} style={{ cursor: "pointer" }} className="text-dark" >
                                          <CardHeader id="headingTwo">
                                            <h6 className="m-0 font-14">
                                              {" "}Guidelines:{" "}
                                              <i className={this.state.col2 ? "mdi mdi-minus float-end accor-plus-icon" : "mdi mdi-plus float-end accor-plus-icon"}></i>
                                            </h6>
                                          </CardHeader>
                                        </Link>
                                        <Collapse isOpen={this.state.col2}>
                                          <CardBody>
                                            <p>
                                            {guidelines.map((guideline) => {
                                              return (<>➢ {guideline.point}<br /></>)
                                            })}
                                            </p>
                                            
                                          </CardBody>
                                        </Collapse>{" "}
                                      </Card>
                                      <Card className="mb-1 shadow-none">
                                        <Link to="#" onClick={this.t_col3} style={{ cursor: "pointer" }} className="text-dark" >
                                          <CardHeader id="headingThree">
                                            <h6 className="m-0 font-14">
                                            Cancellation / Amendment Terms:
                                              <i className={this.state.col3 ? "mdi mdi-minus float-end accor-plus-icon" : "mdi mdi-plus float-end accor-plus-icon"}></i>
                                            </h6>
                                          </CardHeader>
                                        </Link>
                                        <Collapse isOpen={this.state.col3}>
                                          <CardBody>
                                          <p>
                                            {terms.map((term) => {
                                              return (<>➢ {term.point}<br /></>)
                                            })}
                                            </p>
                                          </CardBody>
                                        </Collapse>{" "}
                                      </Card>
                                    </div>
                                  </Col>
                                </Row>
                              </div>
                            </Col>
                          </Row>
                 
                          <div className="mt-4">
                            <h5 className="font-size-14 mb-3">
                              Additional Details:{" "}
                            </h5>
                            <div className="hotel-desc">
                              <Nav tabs className="nav-tabs-custom">
                                <NavItem>
                                  <NavLink
                                    className={classnames({
                                      active:
                                        this.state.activepricingTab ===
                                        "hotel_detail",
                                    })}
                                    onClick={() => {
                                      this.togglepricing("hotel_detail");
                                    }}
                                  >
                                    Hotel Details
                                  </NavLink>
                                </NavItem>
                                {this.obj?<>
                                <NavItem>
                                  <NavLink
                                    className={classnames({
                                      active:
                                        this.state.activepricingTab ===
                                        "pricing",
                                    })}
                                    onClick={() => {
                                      this.togglepricing("pricing");
                                    }}
                                  >
                                    Pricing
                                  </NavLink>
                                </NavItem>
                                <NavItem>
                                  <NavLink
                                    className={classnames({
                                      active:
                                        this.state.activepricingTab ===
                                        "seasons",
                                    })}
                                    onClick={() => {
                                      this.togglepricing("seasons");
                                    }}
                                  >
                                    Seasons
                                  </NavLink>
                                </NavItem>
                                <NavItem>
                                  <NavLink
                                    className={classnames({
                                      active:
                                        this.state.activepricingTab ===
                                        "payment",
                                    })}
                                    onClick={() => {
                                      this.togglepricing("payment");
                                    }}
                                  >
                                    Payment Detail
                                  </NavLink>
                                </NavItem>
                                </>:null}
                              </Nav>
                              <TabContent
                                activeTab={this.state.activepricingTab}
                                className="border border-top-0 p-4"
                              >
                                <TabPane tabId="hotel_detail">
                                  <div className="table-responsive">
                                      <Table className="table-nowrap mb-0">
                                        <tbody>
                                        <tr key={'name'}>
                                            <th
                                            scope="row"
                                            style={{ width: "20%" }}
                                            >
                                            {"Name"}
                                            </th>
                                            <td>{hotel.name}</td>
                                        </tr>
                                        <tr key={'address'}>
                                            <th
                                            scope="row"
                                            style={{ width: "20%" }}
                                            >
                                            {"Address"}
                                            </th>
                                            <td>{hotel.address}</td>
                                        </tr>
                                        <tr key={'zip_code'}>
                                            <th
                                            scope="row"
                                            style={{ width: "20%" }}
                                            >
                                            {"Pin Code"}
                                            </th>
                                            <td>{hotel.zip_code}</td>
                                        </tr>
                                        <tr key={'coordinates'}>
                                            <th
                                            scope="row"
                                            style={{ width: "20%" }}
                                            >
                                            {"Coordinates"}
                                            </th>
                                            <td><a href={"https://www.google.com/search?q="+hotel.coordinates} target="__blank">{hotel.coordinates}</a></td>
                                        </tr>
                                        <tr key={'hotel_type'}>
                                            <th
                                            scope="row"
                                            style={{ width: "20%" }}
                                            >
                                            {"Hotel Type"}
                                            </th>
                                            <td>{hotel.hotel_type.name}</td>
                                        </tr>
                                        <tr key={'destination'}>
                                            <th
                                            scope="row"
                                            style={{ width: "20%" }}
                                            >
                                            {"Destination"}
                                            </th>
                                            <td>{hotel.destination.name}</td>
                                        </tr>
                                        <tr key={'place'}>
                                            <th
                                            scope="row"
                                            style={{ width: "20%" }}
                                            >
                                            {"Place"}
                                            </th>
                                            <td>{hotel.place.name}</td>
                                        </tr>
                                        {this.obj?<>
                                        <tr key={'contact_person'}>
                                            <th
                                            scope="row"
                                            style={{ width: "20%" }}
                                            >
                                            {"Contact Person"}
                                            </th>
                                            <td>{hotel.contact_person}</td>
                                        </tr>
                                        <tr key={'Contact Number'}>
                                            <th
                                            scope="row"
                                            style={{ width: "20%" }}
                                            >
                                            {"Contact"}
                                            </th>
                                            <td>{hotel.contact}</td>
                                        </tr>
                                        <tr key={'Contact Email'}>
                                            <th
                                            scope="row"
                                            style={{ width: "20%" }}
                                            >
                                            {"Contact Email"}
                                            </th>
                                            <td>{hotel.contact_email}</td>
                                        </tr>
                                        </>:null}
                                        {hotel.place.nearest_bus_station?
                                        <tr key={'nearest_bus_station'}>
                                            <th
                                            scope="row"
                                            style={{ width: "20%" }}
                                            >
                                            {"Nearest Bus Station"}
                                            </th>
                                            <td>{hotel.place.nearest_bus_station.name} ({hotel.place.bus_station_distance} km)</td>
                                        </tr>
                                        : null}

                                        {hotel.place.nearest_railway_station?
                                        <tr key={'nearest_railway_station'}>
                                            <th
                                            scope="row"
                                            style={{ width: "20%" }}
                                            >
                                            {"Nearest Railway Station"}
                                            </th>
                                            <td>{hotel.place.nearest_railway_station.name} ({hotel.place.railway_distance} km)</td>
                                        </tr>
                                        :null}
                                        {hotel.place.nearest_airport?
                                        <tr key={'nearest_airport'}>
                                            <th
                                            scope="row"
                                            style={{ width: "20%" }}
                                            >
                                            {"Nearest Airport Station"}
                                            </th>
                                            <td>{hotel.place.nearest_airport.name} ({hotel.place.airport_distance} km)</td>
                                        </tr>
                                        :null}
                                        {this.state.DestinationDistances.map((dist, index) => {
                                    
                                            
                                        return (
                                        <tr key={index}>
                                          <th
                                            scope="row"
                                            style={{ width: "20%" }}
                                            >
                                            {`From ${hotel.destination.name}`}
                                            </th>
                                          <td>{dist.destination.name} ({dist.distance} km)</td> 
                                                                       
                                        </tr>)
                                      
                                        })}

                                      

                                        </tbody>
                                      </Table>
                                  </div>
                                  {this.obj && has_Permission(this.obj?.user, 3, 'edit' ) ?
                                  <Button type="button" className="btn-sm mt-4" onClick={() => this.props.history.push(`/edit-hotel/${hotel.id}`)} color="info"><i className="fas fa-pen"></i></Button>
                                    :null}
                                </TabPane>
                                <TabPane tabId="pricing">
                                  <div className="table-responsive">
                                    <Table className="table-nowrap mb-0">
                                      <tbody>
                                      <tr key={'mainHeading'}>
                                          <th rowSpan="2"
                                          scope="row"
                                          >
                                          {"Room Type"}
                                          </th>
                                          <th rowSpan="2"
                                          scope="row"
                                          >
                                          {"Facilities"}
                                          </th>
                                          <th colSpan="3"
                                          scope="row"
                                          style={{border: 'none', textAlign: 'center'}}
                          
                                          >
                                          {"Off Season"}
                                          </th>
                                         
                                          <th colSpan="3"
                                          scope="row"
                                          style={{border: 'none', textAlign: 'center', background: 'silver'}}
                                          >
                                          {"On Season"}
                                          </th>
                                          {has_Permission(this.obj?.user, 3, 'edit' )?
                                          <th rowSpan="2"
                                            scope="row"
                                            >
                                            {"Action"}
                                          </th>
                                          :""}
                                      </tr>

                                      <tr key={'PricingHeading'}>
                                          <th
                                          scope="row"
                                          >
                                          {"EP Price"}
                                          </th>
                                          <th
                                          scope="row"
                                          >
                                          {"CP Price"}
                                          </th>
                                          <th
                                          scope="row"
                                          >
                                          {"MAP Price"}
                                          </th>
                                          <th
                                          scope="row"
                                          style={{ background: 'silver'}}
                                          >
                                          {"EP Price"}
                                          </th>
                                          <th
                                          scope="row"
                                          style={{ background: 'silver'}}
                                          >
                                          {"CP Price"}
                                          </th>
                                          <th
                                          scope="row"
                                          style={{ background: 'silver'}}
                                          >
                                          {"MAP Price"}
                                          </th>
                                    
                                      </tr>
                                      {pricing.map(
                                          (item, i) => (
                                      <tr key={i}>

                                          <td>{item.room_type.name}</td>
                                          <td>{item.facilities.map(
                                              (facility, i) => {
                                                if (i <=2){
                                                  return (
                                                    facility.name+", "
                                                  )
                                                }
                                              }
                                                
                                          )}
                                          <Link to="#" onClick={()=> this.ShowRoomFacilites(item.facilities)} className="me-3 text-secondary"><i class="fas fa-ellipsis-h"></i></Link>
                                          </td>
                                          <td style={{textAlign: 'center'}}>₹ {item.ep_price}</td>
                                          <td style={{textAlign: 'center'}}>₹ {item.cp_price}</td>
                                          <td style={{textAlign: 'center'}}>₹ {item.map_price}</td>
                                          {/*  */}
                                          <td style={{textAlign: 'center', background: 'silver'}}>₹ {item.on_season_ep_price}</td>
                                          <td style={{textAlign: 'center', background: 'silver'}}>₹ {item.on_season_cp_price}</td>
                                          <td style={{textAlign: 'center', background: 'silver'}}>₹ {item.on_season_map_price}</td>
                                      
                                          <td>
                                          {has_Permission(this.obj?.user, 3, 'edit' )?
                                          <Link to="#" onClick={() => this.HandleEditPricing(item)}  className="text-primary"><i className="mdi mdi-pencil-outline font-size-18"></i></Link>
                                          :""}
                                          {" "}
                                          {has_Permission(this.obj?.user, 3, 'delete' )?
                                          <Link to="#" onClick={() => this.setState({ alert_confirm: true, pricing_id:item.id })}  className="text-danger"><i className="mdi mdi-trash-can font-size-18"></i></Link>
                                          :""}
                                          </td>
                                      </tr>
                                          ))}
                                    

                                      </tbody>
                                    </Table>
                                  </div>
                                  {has_Permission(this.obj?.user, 3, 'edit' )?
                                  <Button type="button" className="btn-sm mt-4" onClick={() => this.props.history.push(`/hotel-pricing/${hotel.id}`)} color="info"><i className=" fas fa-plus"></i></Button>
                                  :""}
                                </TabPane>
                                <TabPane tabId="seasons">
                                  <div className="table-responsive">
                                    <Table className="table-nowrap mb-0">
                                      <tbody>
                                      <tr key={'SeasonsHeading'}>
                                          <th
                                          scope="row"
                                          >
                                          {"Srart"}
                                          </th>
                                          <th
                                          scope="row"
                                          >
                                          {"End"}
                                          </th>
                                        {has_Permission(this.obj?.user, 3, 'edit' )?
                                          <th
                                          scope="row"
                                          >
                                          {"Action"}
                                          </th>
                                        :""}
                                      </tr>
                                      {this.state.seasons.map(
                                          (item, i) => (
                                      <tr key={"season"+i}>
                                          <td>{item.start_date} {months_name[item.start_month-1]}</td>
                                          <td>{item.end_date} {months_name[item.end_month-1]}</td>
                                          <td>
                                          {has_Permission(this.obj?.user, 3, 'edit' )?
                                            <Link to="#" onClick={() => this.handleSeasonEdit(item)}  className="text-primary"><i className="mdi mdi-pencil-outline font-size-18"></i></Link>
                                          :""}
                                          {" "}
                                          {has_Permission(this.obj?.user, 3, 'delete' )?
                                            <Link to="#" onClick={() => this.setState({ season_alert_confirm: true, pricing_id:item.id })}  className="text-danger"><i className="mdi mdi-trash-can font-size-18"></i></Link>
                                          :""}
                                          </td>
                                      </tr>
                                          ))}
                                      </tbody>
                                    </Table>
                                  </div>
                                  {has_Permission(this.obj?.user, 3, 'edit' )?
                                    <Button type="button" className="btn-sm mt-4" onClick={this.tog_AddSeason} color="info"><i className=" fas fa-plus"></i></Button>
                                  :""}
                                </TabPane>
                                <TabPane tabId="payment">
                                  <div className="table-responsive">
                                      <Table className="table-nowrap mb-0">
                                        <tbody>
                                        <tr key={'acc_name'}>
                                            <th
                                            scope="row"
                                            style={{ width: "20%" }}
                                            >
                                            {"Account Name"}
                                            </th>
                                            <td>{bank_detail?bank_detail.account_name:""}</td>
                                        </tr>
                                        <tr key={'acc_number'}>
                                            <th
                                            scope="row"
                                            style={{ width: "20%" }}
                                            >
                                            {"Account Number"}
                                            </th>
                                            <td>{bank_detail?bank_detail.account_no:""}</td>
                                        </tr>
                                        <tr key={'bank_n'}>
                                            <th
                                            scope="row"
                                            style={{ width: "20%" }}
                                            >
                                            {"Bank Name"}
                                            </th>
                                            <td>{bank_detail?bank_detail.bank_name:""}</td>
                                        </tr>
                                        <tr key={'bank_branch'}>
                                            <th
                                            scope="row"
                                            style={{ width: "20%" }}
                                            >
                                            {"Branch"}
                                            </th>
                                            <td>{bank_detail?bank_detail.branch_name:""}</td>
                                        </tr>
                                        <tr key={'acc_ifsc'}>
                                            <th
                                            scope="row"
                                            style={{ width: "20%" }}
                                            >
                                            {"IFSC code"}
                                            </th>
                                            <td>{bank_detail?bank_detail.ifsc:""}</td>
                                        </tr>
                                        <tr key={'upi_bank_n'}>
                                          <th
                                          scope="row"
                                          style={{ width: "20%" }}
                                          >
                                          {"UPI Bank Name"}
                                          </th>
                                          <td>{bank_detail?bank_detail.upi_bank_name:""}</td>
                                        </tr>
                                        <tr key={'upi_user_n'}>
                                          <th
                                          scope="row"
                                          style={{ width: "20%" }}
                                          >
                                          {"UPI User Name"}
                                          </th>
                                          <td>{bank_detail?bank_detail.upi_user_name:""}</td>
                                        </tr>
                                        <tr key={'acc_upi'}>
                                            <th
                                            scope="row"
                                            style={{ width: "20%" }}
                                            >
                                            {"UPI"}
                                            </th>
                                            <td>{bank_detail?bank_detail.upi:""}</td>
                                        </tr>
                                       
                                        </tbody>
                                      </Table>
                                  </div>
                                  {has_Permission(this.obj?.user, 3, 'edit' )?
                                    <Button type="button" className="btn-sm mt-4" onClick={this.tog_edit_bank_detail} color="info"><i className="fas fa-pen"></i></Button>
                                  :""}  
                                  </TabPane>
                              </TabContent>
                            </div>
                          </div>
                        </CardBody>
                      </Card>
                    </Col>
                  </Row>
                  :
                  <div className="d-flex align-items-center justify-content-center min-vh-100">
            
                      <Spinner type="grow" className="me-2" color="secondary" />
                      <Spinner type="grow" className="me-2" color="secondary" />
                      <Spinner type="grow" className="me-2" color="secondary" />
                      <Spinner type="grow" className="me-2" color="secondary" />
              
                  </div>
                }
              </React.Fragment>
              {/* Add Room Facility */}
            <Col sm={6} md={4} xl={3} className="mt-4">
               
               <Modal
                 isOpen={this.state.model_room_facility}
                 toggle={this.tog_room_facility}
                 centered={true}
               >
                 <ModalHeader toggle={() => this.setState({ model_room_facility: false })}>
                 Room Facilities
                 </ModalHeader>
                 <ModalBody>
                 <ul className="list-unstyled hotel-desc-list">
                    <Row>
                    
                    {this.state.room_facilities.map(
                        (item, i) => ( 
                          <Col md="6">
                            <li key={i}>
                              <i className="mdi mdi-circle-medium me-1 align-middle"></i>{" "}
                              {item.name}
                            </li>
                          </Col>
                        ))
                    }  
                    </Row>
                  
                  </ul>
                   

                 </ModalBody>
               </Modal>
             </Col>
            {/* Add Room Facility */}
            <Col sm={6} md={4} xl={3} className="mt-4">
               
               <Modal
                 isOpen={this.state.model_facility}
                 toggle={this.tog_facility}
                 centered={true}
               >
                 <ModalHeader toggle={() => this.setState({ model_facility: false })}>
                 Add Room Facility
                 </ModalHeader>
                 <ModalBody>
                   <AvForm className="needs-validation" onValidSubmit={this.handleFacilitySubmit} >
           
                     <Row>
                       <Col md="6">
                         <div className="mb-3">
                           <Label className="form-label " htmlFor="name"> Facility Name</Label>
                           <AvField
                             name="name"
                             placeholder="Facility Name"
                             type="text"
                             errorMessage="Enter Facility Name"
                             className="form-control"
                             validate={{ required: { value: true } }}
                             id="name"
                             
                           />
                         </div>
                       </Col> 
                     </Row>
                                       
                     <FormGroup className="mb-0">
                       {this.state.facilityloading?(
                         <Spinner className="me-2 mt-2" color="primary" />
                       ):(
                         <div>
                     
                       <Button type="submit" color="primary" className="me-1">
                         Submit
                       </Button>
                       </div>
                         )}
                     </FormGroup>     
                   </AvForm>

                 </ModalBody>
               </Modal>
             </Col>
            {/* Model Edit Pricing */}
            <Col sm={6} md={4} xl={3} className="mt-4">
              
              <Modal
                isOpen={this.state.model_EditPricing}
                toggle={() => this.tog_EditPricing()}
                centered={true}
              >
                <ModalHeader toggle={() => this.setState({ model_EditPricing: false })}>
                Edit Price for {selected_pricing.room_type?selected_pricing.room_type.name:""}
                </ModalHeader>
                <ModalBody>
                  <AvForm className="needs-validation" onValidSubmit={this.handlePricingSubmit} >
                    <Row>
                    <Col md="12">
                        <div className="mb-3">
                            <Label className="form-label">Category</Label>
                            <Select 
                            onChange={(e) => this.setState({selectedRoom:e})}
                            value={this.state.selectedRoom}
                            options={this.state.RoomGroup}
                            classNamePrefix="select2-selection"
                            />

                        </div>
                          
                                  
                      </Col>
                    </Row>
                    <Row>    
                      <Col md="12">
                          <div className="mb-3">
                              <Label className="form-label">Facilities</Label>
                              <Select 
  value={this.state.selectedFacilities}
  isMulti={true}
  onChange={this.handleselectedFacilityGroup}
  options={this.state.FacilityGroup}
  components={{ Menu: HotelFacility }}
  classNamePrefix="select2-selection"
/>


                          </div>
                      </Col>
                    </Row>  
          
                    <Row>
                    
                      <Col md="6">
                      <h5 className="font-size-14 mb-3">
                              Off Season
                            </h5>
                        <Row>
                          <Col md="12">
                            <div className="mb-3">
                                <Label className="form-label " htmlFor="price">EP Price</Label>
                                <AvField
                                name="ep_price"
                                placeholder="European Plan Price"
                                type="number"
                                value={parseInt(selected_pricing.ep_price)}
                                className="form-control"
                                errorMessage="Enter Only Number"
                                validate={{
                                    required: { value: true },
                                    pattern: {
                                    value: "^[0-9]+$",
                                    errorMessage: "Only Numbers"
                                    }
                                }}
                                id="price"
                                />
                            </div>
                          </Col>
                        </Row>
                        <Row>
                          <Col md="12">
                              <div className="mb-3">
                                  <Label className="form-label " htmlFor="price">CP Price</Label>
                                  <AvField
                                  name="cp_price"
                                  placeholder="Continental Plan Price"
                                  type="number"
                                  value={parseInt(selected_pricing.cp_price)}
                                  className="form-control"
                                  errorMessage="Enter Only Number"
                                  validate={{
                                      required: { value: true },
                                      pattern: {
                                      value: "^[0-9]+$",
                                      errorMessage: "Only Numbers"
                                      }
                                  }}
                                  id="price"
                                  />
                              </div>
                            </Col>
                        </Row>
                        <Row>   
                          <Col md="12">
                            <div className="mb-3">
                                <Label className="form-label " htmlFor="price">MAP Price</Label>
                                <AvField
                                name="map_price"
                                placeholder="Modified American Plan Price"
                                type="number"
                                value={parseInt(selected_pricing.map_price)}
                                className="form-control"
                                errorMessage="Enter Only Number"
                                validate={{
                                    required: { value: true },
                                    pattern: {
                                    value: "^[0-9]+$",
                                    errorMessage: "Only Numbers"
                                    }
                                }}
                                id="price"
                                />
                            </div>
                          </Col>
                        </Row>
                      
                      </Col>
                      <Col md="6">
                      <h5 className="font-size-14 mb-3">
                              On Season 
                            </h5>
                        <Row>
                          <Col md="12">
                            <div className="mb-3">
                                <Label className="form-label " htmlFor="on_season_ep_price">EP Price</Label>
                                <AvField
                                name="on_season_ep_price"
                                placeholder="European Plan Price"
                                type="number"
                                value={parseInt(selected_pricing.on_season_ep_price)}
                                className="form-control"
                                errorMessage="Enter Only Number"
                                validate={{
                                    required: { value: true },
                                    pattern: {
                                    value: "^[0-9]+$",
                                    errorMessage: "Only Numbers"
                                    }
                                }}
                                id="on_season_ep_price"
                                />
                            </div>
                          </Col>
                        </Row>
                        <Row>
                          <Col md="12">
                              <div className="mb-3">
                                  <Label className="form-label " htmlFor="on_season_cp_price">CP Price</Label>
                                  <AvField
                                  name="on_season_cp_price"
                                  placeholder="Continental Plan Price"
                                  type="number"
                                  value={parseInt(selected_pricing.on_season_cp_price)}
                                  className="form-control"
                                  errorMessage="Enter Only Number"
                                  validate={{
                                      required: { value: true },
                                      pattern: {
                                      value: "^[0-9]+$",
                                      errorMessage: "Only Numbers"
                                      }
                                  }}
                                  id="on_season_cp_price"
                                  />
                              </div>
                            </Col>
                        </Row>
                        <Row>   
                          <Col md="12">
                            <div className="mb-3">
                                <Label className="form-label " htmlFor="on_season_map_price">MAP Price</Label>
                                <AvField
                                name="on_season_map_price"
                                placeholder="Modified American Plan Price"
                                type="number"
                                value={parseInt(selected_pricing.on_season_map_price)}
                                className="form-control"
                                errorMessage="Enter Only Number"
                                validate={{
                                    required: { value: true },
                                    pattern: {
                                    value: "^[0-9]+$",
                                    errorMessage: "Only Numbers"
                                    }
                                }}
                                id="on_season_map_price"
                                />
                            </div>
                          </Col>
                        </Row>
                      </Col>   
                    </Row>
                    
                                      
                    <FormGroup className="mb-0">
                      {this.state.editpriceloading?(
                        <Spinner className="me-2 mt-2" color="primary" />
                      ):(
                        <div>
                    
                      <Button type="submit" color="primary" className="me-1">
                        Submit
                      </Button>
                      </div>
                        )}
                    </FormGroup>     
                  </AvForm>

                </ModalBody>
              </Modal>
            </Col>
            {/* Add Season */}
            <Col sm={6} md={4} xl={3} className="mt-4">
              
              <Modal
                isOpen={this.state.model_AddSeason}
                toggle={() => this.tog_AddSeason()}
                centered={true}
              >
                <ModalHeader toggle={() => this.setState({ model_AddSeason: false })}>
                Add Season 
                </ModalHeader>
                <ModalBody>
                  <AvForm className="needs-validation" onValidSubmit={this.handleSeasonSubmit} >
                  <Row> 
                    <Col md="6">
                          <div className="mb-3">
                              <Label className="form-label">Start Date</Label>
                              <Select 
                              value={this.state.selectedStartDate}
                              onChange={this.handleSelectedStartDate}
                              options={Dates}
                              classNamePrefix="select2-selection"
                              />

                          </div>
                      </Col> 
                      <Col md="6">
                          <div className="mb-3">
                              <Label className="form-label">Start Month</Label>
                              <Select 
                              value={this.state.selectedStartMonth}
                              onChange={this.handleSelectedStartMonth}
                              options={Months}
                              classNamePrefix="select2-selection"
                              />

                          </div>
                      </Col>
                    </Row>  
                    <Row> 
                    <Col md="6">
                          <div className="mb-3">
                              <Label className="form-label">End Date</Label>
                              <Select 
                              value={this.state.selectedEndDate}
                              onChange={this.handleSelectedEndDate}
                              options={Dates}
                              classNamePrefix="select2-selection"
                              />

                          </div>
                      </Col> 
                      <Col md="6">
                          <div className="mb-3">
                              <Label className="form-label">End Month</Label>
                              <Select 
                              value={this.state.selectedEndMonth}
                              onChange={this.handleSelectedEndMonth}
                              options={Months}
                              classNamePrefix="select2-selection"
                              />

                          </div>
                      </Col>
                    </Row>  
                 
          
                                      
                    <FormGroup className="mb-0">
                      {this.state.addSeasonloading?(
                        <Spinner className="me-2 mt-2" color="primary" />
                      ):(
                        <div>
                    
                      <Button type="submit" color="primary" className="me-1">
                        Submit
                      </Button>
                      </div>
                        )}
                    </FormGroup>     
                  </AvForm>

                </ModalBody>
              </Modal>
            </Col>
            {/* Edit Season */}
            <Col sm={6} md={4} xl={3} className="mt-4">
              
              <Modal
                isOpen={this.state.model_EditSeason}
                toggle={() => {this.tog_EditSeason(); this.setState({ pricing_id:""})}}
                centered={true}
              >
                <ModalHeader toggle={() => {this.tog_EditSeason(); this.setState({ pricing_id:""})}}>
                Edit Season 
                </ModalHeader>
                <ModalBody>
                  <AvForm className="needs-validation" onValidSubmit={this.handleEditSeasonSubmit} >
                  <Row> 
                  

                    <Col md="6">
                          <div className="mb-3">
                              <Label className="form-label">Start Date</Label>
                              <Select 
                              value={this.state.selectedStartDate}
                              onChange={this.handleSelectedStartDate}
                              options={Dates}
                              classNamePrefix="select2-selection"
                              />

                          </div>
                      </Col> 
                      <Col md="6">
                          <div className="mb-3">
                              <Label className="form-label">Start Month</Label>
                              <Select 
                              value={this.state.selectedStartMonth}
                              onChange={this.handleSelectedStartMonth}
                              options={Months}
                              classNamePrefix="select2-selection"
                              />

                          </div>
                      </Col>
                    </Row>  
                    <Row> 
                    <Col md="6">
                          <div className="mb-3">
                              <Label className="form-label">End Date</Label>
                              <Select 
                              value={this.state.selectedEndDate}
                              onChange={this.handleSelectedEndDate}
                              options={Dates}
                              classNamePrefix="select2-selection"
                              />

                          </div>
                      </Col> 
                      <Col md="6">
                          <div className="mb-3">
                              <Label className="form-label">End Month</Label>
                              <Select 
                              value={this.state.selectedEndMonth}
                              onChange={this.handleSelectedEndMonth}
                              options={Months}
                              classNamePrefix="select2-selection"
                              />

                          </div>
                      </Col>
                    </Row>  
                 
          
                                      
                    <FormGroup className="mb-0">
                      {this.state.editSeasonloading?(
                        <Spinner className="me-2 mt-2" color="primary" />
                      ):(
                        <div>
                    
                      <Button type="submit" color="primary" className="me-1">
                        Submit
                      </Button>
                      </div>
                        )}
                    </FormGroup>     
                  </AvForm>

                </ModalBody>
              </Modal>
            </Col>
            {/* Add/Edit Bank Detail  */}
            <Col sm={6} md={4} xl={3} className="mt-4">
               
               <Modal
                 isOpen={this.state.model_edit_bank_detail}
                 toggle={this.tog_edit_bank_detail}
                 centered={true}
               >
                 <ModalHeader toggle={this.tog_edit_bank_detail}>
                 {bank_detail?"Edit ": "Add "}Payment Detail
                 </ModalHeader>
                 <ModalBody>
                   <AvForm className="needs-validation" onValidSubmit={this.handleBankDetailSubmit} >
                   <h6 className="mb-4">Bank Details </h6>
                      <Row>
                          <Col md="6">
                            <div className="mb-3">
                              <Label className="form-label" htmlFor="account_name">Account Name</Label>
                                <AvField
                                    name="account_name"
                                    type="text"
                                    placeholder="Account Name"
                                    errorMessage="Enter Account Name"
                                    className="form-control"
                                    value= {bank_detail?.account_name}
                                    validate={{ required: { value: true } }}
                                    id="account_name"
                                    
                                />
                              </div>
                            </Col> 
                            <Col md={6}>
                                <div className="mb-3">
                                    <AvField
                                        name="account_no"
                                        label="Account Number"
                                        placeholder="Account Number"
                                        type="number"
                                        value= {bank_detail?.account_no}
                                        errorMessage="Enter Only Digits"
                                        validate={{
                                            required: { value: true },
                                            pattern: {
                                            value: "^[0-9]+$",
                                            errorMessage: "Only Digits"
                                            }
                                        }}
                                        />
                                </div>
                            </Col>
                              
                      </Row>           
     
                      <Row>
                          <Col md="6">
                              <div className="mb-3">
                              <Label className="form-label " htmlFor="bank_name">Bank Name</Label>
                              <AvField
                                  name="bank_name"
                                  placeholder="Bank Name"
                                  type="text"
                                  errorMessage="Enter Bank Name"
                                  className="form-control"
                                  value= {bank_detail?.bank_name}
                                  validate={{ required: { value: true } }}
                                  id="bank_name"
                                  
                              />
                              </div>
                          </Col> 
                          <Col md="6">
                              <div className="mb-3">
                              <Label className="form-label " htmlFor="branch_name">Branch Name</Label>
                              <AvField
                                  name="branch_name"
                                  type="text"
                                  placeholder="Branch Name"
                                  errorMessage="Enter Branch Name"
                                  className="form-control"
                                  value= {bank_detail?.branch_name}
                                  validate={{ required: { value: true } }}
                                  id="branch_name"
                                  
                              />
                              </div>
                          </Col> 
                          
                      </Row>
                      <Row>
                          <Col md="6">
                              <div className="mb-3">
                              <Label className="form-label " htmlFor="ifsc">IFSC Code</Label>
                              <AvField
                                  name="ifsc"
                                  type="text"
                                  placeholder="IFSC Code"
                                  errorMessage="Enter IFSC Code"
                                  value= {bank_detail?.ifsc}
                                  className="form-control"
                                  validate={{ required: { value: true } }}
                                  id="ifsc"  
                              />
                              </div>
                          </Col> 
                      </Row>
                      <hr />
                      <h6 className="mb-4">UPI Details </h6>
                      <Row>
                        <Col md="6">
                          <div className="mb-3">
                            <Label className="form-label " htmlFor="upi_user_name">User Name</Label>
                            <AvField
                              name="upi_user_name"
                              placeholder="User Name"
                              type="text"
                              errorMessage="Enter User Name"
                              className="form-control"
                              value= {bank_detail?.upi_user_name}
                              validate={{ required: { value: true } }}
                              id="upi_user_name"
                                
                            />
                          </div>
                        </Col> 
                        <Col md="6">
                            <div className="mb-3">
                            <Label className="form-label " htmlFor="upi_bank_name">Bank Name</Label>
                            <AvField
                                name="upi_bank_name"
                                placeholder="UPI Bank Name"
                                type="text"
                                errorMessage="Enter Bank Name"
                                className="form-control"
                                value= {bank_detail?.upi_bank_name}
                                validate={{ required: { value: true } }}
                                id="upi_bank_name"
                            />
                            </div>
                        </Col> 
                      </Row>
                      <Row>
                      <Col md="6">
                          <div className="mb-3">
                          <Label className="form-label " htmlFor="upi">UPI ID</Label>
                          <AvField
                              name="upi"
                              type="text"
                              placeholder="UPI"
                              errorMessage="Enter UPI"
                              className="form-control"
                              value= {bank_detail?.upi}
                              validate={{ required: { value: true } }}
                              id="upi"
                          />
                          </div>
                        </Col> 
                      </Row>               
                     <FormGroup className="mb-0">
                       {this.state.loading_bank_detail?(
                         <Spinner className="me-2 mt-2" color="primary" />
                       ):(
                         <div>
                     
                       <Button type="submit" color="primary" className="me-1">
                         Submit
                       </Button>
                       </div>
                         )}
                     </FormGroup>     
                   </AvForm>
     
                 </ModalBody>
               </Modal>
            </Col>

            {/* Delete Model  */}
            {this.state.alert_confirm ? (
                <SweetAlert
                title="Are you sure?"
                warning
                showCancel
                confirmBtnBsStyle="success"
                cancelBtnBsStyle="danger"
                onConfirm={() => this.handlePricingDelete(this.state.pricing_id)}
                onCancel={() =>
                    this.setState({
                        alert_confirm: false,
                        pricing_id:"",

                    })
                }
                >
                You won't be able to revert this!
                </SweetAlert>
            ) : null}

            {this.state.success_confirm ? (
                <SweetAlert
                success
                title={this.state.dynamic_title}
                confirmBtnBsStyle="success"
                cancelBtnBsStyle="danger"
                onConfirm={() => this.setState({ success_confirm: false, alert_confirm : false, pricing_id:"" })}
                >
                    {this.state.dynamic_description}
                </SweetAlert>
            ) : null}
            {/* Delete Season */}
            {this.state.season_alert_confirm ? (
                <SweetAlert
                title="Are you sure?"
                warning
                showCancel
                confirmBtnBsStyle="success"
                cancelBtnBsStyle="danger"
                onConfirm={() => this.handleSeasonDelete(this.state.pricing_id)}
                onCancel={() =>
                    this.setState({
                      season_alert_confirm: false,
                        pricing_id:"",

                    })
                }
                >
                You won't be able to revert this!
                </SweetAlert>
            ) : null}

            {this.state.season_success_confirm ? (
                <SweetAlert
                success
                title={this.state.dynamic_title}
                confirmBtnBsStyle="success"
                cancelBtnBsStyle="danger"
                onConfirm={() => this.setState({ season_success_confirm: false, season_alert_confirm : false,  })}
                >
                    {this.state.dynamic_description}
                </SweetAlert>
            ) : null}

          </Container>
        </div>
      </React.Fragment>
    ); }
}


export default HotelDetailPage ;
